import type {Agent} from 'api/types';

export const removeMentionedIn = (agent: Agent) => {
  agent.links = agent.links?.filter(link => link.role !== 'mentionedIn.work');
};
